// extracted by mini-css-extract-plugin
module.exports = {"disqus":"styles_disqus__Ks7PY","commentsButton":"styles_commentsButton__Oo_2Z","disqusEmbed":"styles_disqusEmbed__gZg_Y","showEmbed":"styles_showEmbed__yDA0u"};